export const checkBlogProgress = function (
    pixels,
    pageHeight,
    isSingleBlog,
    progressBar
  ) {
    if (!isSingleBlog) return;
  
    const progress = (100 * pixels) / pageHeight;
  
    if (progressBar) progressBar.style.width = progress + "%";
  };
  